const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de ordenes de salida',
  PAGE_DESCRIPTION:
    'Desde aqui puedes ver las ordenes de salida que tienes activas en este almacen. Tambien puedes crear y procesar nuevas ordenes de salida, intenta usando el botón "Crear orden de salida".'
};

export default HELPER_TEXTS;
